import { API } from '../../api';
import { DimaContext } from '../../DimaContext';
import { Link, useParams, useRouteMatch } from 'react-router-dom';
import { PageHeader, Row, Spin, notification } from 'antd';
import FieldsTable from './fieldsTable';
import React, { useContext, useEffect, useState } from 'react';

const JobType = () => {
  const context = useContext(DimaContext);
  const { name } = useParams();
  const [jobType, setJobType] = useState({});
  const [loading, setLoading] = useState(false);
  const [actionTypes, setActionTypes] = useState([]);
  const { url } = useRouteMatch();

  const generateRouteOnFieldDisplay = routeOn => {
    const findField = (fieldName, actionTypesList) => {
      if (!fieldName || !actionTypesList) return null;

      for (const actionType of actionTypesList) {
        for (const outputField of actionType.outputFields ?? []) {
          if (outputField.name === fieldName) {
            return outputField;
          }

          const nested = outputField.nested.find(nestedField => nestedField.name === fieldName);
          if (nested) return nested;
        }
      }

      return null;
    };

    const routeOnField = findField(routeOn, actionTypes);

    if (!routeOnField) {
      return <p />;
    }

    return (
      <div>
        <div style={{ color: 'black', fontSize: '14px', fontWeight: 'bold', marginTop: '20px' }}>
          RouteOn Field:
        </div>
        <FieldsTable fields={[routeOnField]} loading={loading} />
      </div>
    );
  };

  const fetchJobTypeByName = async () => {
    setLoading(true);

    try {
      const { data } = await API.get(`/dis/jobTypes/${name}?clientId=${context.client.id}`);
      setJobType(data);
      setActionTypes(
        data.actionTypesOrder.map(el => {
          return { name: el, id: null };
        }),
      );
    } catch (err) {
      notification.error({
        message: 'Error',
        description: 'Failed to get Job Type',
        duration: 3,
        placement: 'topLeft',
      });
    }

    setLoading(false);
  };

  const fetchActionTypes = async () => {
    const fetchedActionTypes = [];

    if (jobType.actionTypesOrder) {
      for (const actionType of jobType.actionTypesOrder) {
        try {
          const { data } = await API.get(
            `/dis/actionTypes/${actionType}?clientId=${context.client.id}`,
          );

          if (data) {
            fetchedActionTypes.push(data);
          }
        } catch (err) {
          notification.error({
            message: 'Error',
            description: `Failed to get link for Action Type "${actionType.name}": ${err}`,
            duration: 3,
            placement: 'topLeft',
          });
        }
      }

      setActionTypes(fetchedActionTypes);
    }
  };

  const actionTypeLink = actionType => {
    const urlBase = url.slice(0, Math.max(0, url.indexOf('/jobType')));
    const linkUrl = `${urlBase}/actionType/${actionType}`;
    return <Link to={linkUrl}>{actionType}</Link>;
  };

  useEffect(() => {
    fetchJobTypeByName();
  }, [name]);

  useEffect(() => {
    fetchActionTypes();
  }, [jobType]);

  return (
    <>
      <PageHeader
        className="site-page-header"
        onBack={() => window.history.back()}
        title="Job Type Detail"
      />
      <Spin spinning={loading}>
        <Row>
          <p>
            <span style={{ fontWeight: 'bold' }}>Name: </span>
            {jobType?.name}
          </p>
        </Row>
        <Row>
          <p>
            <span style={{ fontWeight: 'bold' }}>Description: </span>
            {jobType?.description}
          </p>
        </Row>
        <div style={{ color: 'black', fontSize: '14px', fontWeight: 'bold' }}>
          Action Types Order
        </div>
        <div style={{ color: 'black', marginBottom: '10px' }}>
          <ol style={{ listStyle: 'none', paddingLeft: '0px' }}>
            {actionTypes?.map((el, index) => {
              return (
                <li>
                  <span style={{ marginRight: '10px' }}>{index + 1}.</span>
                  {actionTypeLink(el.name)}
                </li>
              );
            })}
          </ol>
        </div>
        {generateRouteOnFieldDisplay(jobType.routeOn)}
      </Spin>
    </>
  );
};

export default JobType;
